import App from 'modules/App';
export const getSupportUrl = (isMobileDisplayMode)=>{
    if (!process.env.BROWSER) return null;
    return isMobileDisplayMode ? `${App.constants.MOBILE_SUPPORT_URL}?display_mode=mobile&from=${encodeURIComponent(window.location.href)}` : App.constants.SUPPORT_URL;
};
